import * as Yup from "yup";

export const validationSchema = Yup.object({
  name: Yup.string()
    .min(2, "El nombre debe tener al menos 2 caracteres")
    .max(50, "El nombre no debe tener más de 50 caracteres")
    .required("Este campo es obligatorio"),
  email: Yup.string().email("Debe ser un email válido").required("Este campo es obligatorio"),
  id_document: Yup.string().required("Este campo es obligatorio"),
  position: Yup.string().required("Este campo es obligatorio"),
  institution: Yup.string().required("Este campo es obligatorio"),
  area: Yup.string().required("Este campo es obligatorio"),
  city: Yup.string().required("Este campo es obligatorio"),
  autoriza: Yup.boolean().oneOf([true], "Debes autorizar el tratamiento de datos").required("Este campo es obligatorio"),
});
